import {createRouter, createWebHistory} from 'vue-router';
import Authentication from '@/views/pages/pages/authentication/authentication.vue'
import LoginInterface from '@/interface/pages/pages/authentication/login.vue'
import LoginGoogleInterface from '@/interface/pages/pages/authentication/login-google.vue'
import Register from '@/views/pages/pages/authentication/register.vue'
import RegisterInterface from '@/interface/pages/pages/authentication/register.vue'
import Forgot_Password from '@/views/pages/pages/authentication/forgot-password.vue'
import Forgot_PasswordInterface from '@/interface/pages/pages/authentication/forgot-password.vue'
import Change_Password from '@/views/pages/pages/authentication/change-password.vue'
import Reset_PasswordInterface from '@/interface/pages/pages/authentication/change-password.vue'
import IndexInterface from '@/interface/pages/home/index.vue'
import Blog from '@/views/pages/blog/blog.vue'
import BlogList from '@/views/pages/blog/blog-list.vue'
import BlogListSidebarLeft from '@/views/pages/blog/blog-list-sidebar-left.vue'
import BlogListSidebarRight from '@/views/pages/blog/blog-list-sidebar-right.vue'
import BlogInterface from '@/interface/pages/blog/blog.vue'
import BlogGridSidebarLeft from '@/views/pages/blog/blog-grid-sidebar-left.vue'
import BlogGridSidebarRight from '@/views/pages/blog/blog-grid-sidebar-right.vue'
import BlogDetails from '@/views/pages/blog/blog-details.vue'
import BlogDetailsInterface from '@/interface/pages/blog/blog-details.vue'
import BlogDetailsSidebarLeft from '@/views/pages/blog/blog-details-sidebar-left.vue'
import BlogDetailsSidebarRight from '@/views/pages/blog/blog-details-sidebar-right.vue'
import BlogCarousel from '@/views/pages/blog/blog-carousel.vue'
import Pages from '@/views/pages/pages/pages.vue'
import Coming_Soon from '@/views/pages/pages/coming-soon.vue'
import Maintenance from '@/views/pages/pages/maintenance.vue'
import PrivacyPolicy from '@/interface/pages/pages/privacy-policy.vue'
import TermsCondition from '@/views/pages/pages/terms-condition.vue'
import Testimonials from '@/views/pages/pages/testimonials/testimonials.vue'
import TestimonialsCarousel from '@/views/pages/pages/testimonials/testimonials-carousel.vue'
import Faq from '@/interface/pages/pages/faq.vue'
import Pricing from '@/views/pages/pages/pricing.vue'
import Gallery from '@/interface/pages/pages/gallery.vue'
import Events from '@/views/pages/pages/events.vue'
import Services from '@/views/pages/pages/services/services.vue'
import OurTeams from '@/views/pages/pages/our-teams.vue'
import AboutUs from '@/interface/pages/pages/about-us/about-us.vue'
import Error_404 from '@/interface/pages/pages/error-404.vue'
import User from '@/views/pages/user/user.vue'
import UserDashboardInterface from '@/interface/pages/user/user-dashboard/user-dashboard.vue'
import UserProfileOthersettingInterface from '@/interface/pages/user/profile-settings/user-profile-othersetting.vue'
import UserSettingPasswordInterface from '@/interface/pages/user/profile-settings/user-setting-password.vue'
import UserProfileInterface from '@/interface/pages/user/profile-settings/user-profile.vue'
import UserWallet from '@/views/pages/user/user-wallet.vue'
import UserInvoice from '@/views/pages/user/user-invoice.vue'
import UserCoaches from '@/views/pages/user/user-coaches.vue'
import UserMatch from '@/interface/pages/user/user-match/user-match.vue'
import UserBookings from '@/views/pages/user/user-bookings/user-bookings.vue'
import UserTournament from '@/interface/pages/user/user-tournament/user-tournament.vue'
import UserComplete from '@/views/pages/user/user-complete/user-complete.vue'
import UserOngoing from '@/views/pages/user/user-ongoing/user-ongoing.vue'
import UserCancelled from '@/views/pages/user/user-cancelled/user-cancelled.vue'
import AllNotifications from '@/interface/pages/user/notification/all-notifications.vue'
import ContactUsInterface from '@/interface/pages/contact-us.vue'
import Coaches from '@/views/pages/coaches/coaches.vue'
import CoachesMap from '@/views/pages/coaches/coaches-map/coaches-map.vue'
import CoachesMapSidebar from '@/views/pages/coaches/coaches-map/coaches-map-sidebar.vue'
import TournamentGrid from '@/interface/pages/tournament/tournament-grid.vue'
import TournamentList from '@/interface/pages/tournament/tournament-list.vue'
import TournamentDetail from '@/interface/pages/tournament/details/tourament-details.vue'
import CoachesList from '@/views/pages/coaches/coaches-list.vue'
import CoachesGridSidebar from '@/views/pages/coaches/coaches-grid-sidebar.vue'
import CoachesListSidebar from '@/views/pages/coaches/coaches-list-sidebar.vue'
import CageDetails from '@/views/pages/coaches/booking/court/cage-details.vue'
import CageOrderConfirm from '@/views/pages/coaches/booking/court/cage-order-confirm.vue'
import CagePersonalinfo from '@/views/pages/coaches/booking/court/cage-personalinfo.vue'
import CageCheckout from '@/views/pages/coaches/booking/court/cage-checkout.vue'
import CoachDetails from '@/views/pages/coaches/booking/coach/coach-details.vue'
import CoachTimedate from '@/views/pages/coaches/booking/coach/coach-timedate.vue'
import CoachPersonalinfo from '@/views/pages/coaches/booking/coach/coach-personalinfo.vue'
import CoachOrderConfirm from '@/views/pages/coaches/booking/coach/coach-order-confirm.vue'
import CoachPayment from '@/views/pages/coaches/booking/coach/coach-payment.vue'
import CoachDetail from '@/views/pages/coaches/coach-detail.vue'
import CoachesInvoice from '@/views/pages/coaches/coaches-invoice.vue'
import CoachRequest from '@/views/pages/coaches/coach-request/coach-request.vue'
import CoachChat from '@/views/pages/coaches/coach-chat.vue'
import CoacheWallet from '@/views/pages/coaches/coach-wallet.vue'
import CoacheEarning from '@/views/pages/coaches/coach-earning/coach-earning.vue'
import EarningCoaching from '@/views/pages/coaches/coach-earning/earning-coaching.vue'
import ListingList from '@/views/pages/coaches/venue/listing-list.vue'
import ListingGrid from '@/views/pages/coaches/venue/listing-grid.vue'
import ListingMap from '@/views/pages/coaches/venue/listing-map.vue'
import VenueDetails from '@/views/pages/coaches/venue/venue-details.vue'
import TournamentRank from '@/interface/pages/tournament/rank.vue'
import AllCourt from '@/views/pages/coaches/court/all-court.vue'
import CourtActive from '@/views/pages/coaches/court/court-active.vue'
import CourtInactive from '@/views/pages/coaches/court/court-inactive.vue'
import AddCourt from '@/views/pages/coaches/add-court/add-court.vue'
import CoachProfile from '@/views/pages/coaches/profile-setting/coach-profile.vue'
import AppointmentDetails from '@/views/pages/coaches/profile-setting/appointment-details.vue'
import SettingLesson from '@/views/pages/coaches/profile-setting/setting-lesson.vue'
import SettingAvailability from '@/views/pages/coaches/profile-setting/setting-availability.vue'
import SettingPassword from '@/views/pages/coaches/profile-setting/setting-password.vue'
import ProfileOthersetting from '@/views/pages/coaches/profile-setting/profile-othersetting.vue'
import CoachBooking from '@/views/pages/coaches/coach-booking/coach-booking.vue'
import BookingCompleted from '@/views/pages/coaches/coach-booking/booking-completed.vue'
import BookingCancelled from '@/views/pages/coaches/coach-booking/booking-cancelled.vue'
import ServiceDetail from '@/views/pages/pages/services/service-detail.vue'
import MyProfile from '@/views/pages/coaches/my-profile.vue'
import {useAuthStore} from '@/stores/auth';

const routes = [
    {
        path: '/:pathMatch(.*)*',
        component: Error_404,
    },
    {
        path: '/',
        redirect: '/trang-chu',
    },
    {
        path: "/login",
        component: LoginInterface
    },
    {
        path: "/login-google",
        component: LoginGoogleInterface
    },
    {
        path: "/register",
        component: RegisterInterface
    },
    {
        path: "/reset-password",
        component: Reset_PasswordInterface
    },
    {
        path: "/forgot-password",
        component: Forgot_PasswordInterface,
    },
    {
        path: "/change-password",
        component: Reset_PasswordInterface,
    },
    {
        path: '/trang-chu',
        name: 'index',
        component: IndexInterface
    },
    {
        path: '/lien-he',
        name: 'contact-us',
        component: ContactUsInterface
    },
    {
        path: '/ve-chung-toi',
        component: AboutUs
    },
    {
        path: "/hinh-anh",
        name: "hinh-anh",
        component: Gallery
    },
    {
        path: "/cau-hoi-thuong-gap",
        component: Faq
    },
    {
        path: "/chinh-sach",
        component: PrivacyPolicy
    },
    {
        path: "/error-404",
        component: Error_404
    },
    {
        path: '/giai-dau',
        component: TournamentGrid
    },
    {
        path: '/list-giai-dau',
        component: TournamentList
    },
    {
        path: '/giai-dau/chi-tiet-giai-dau/:name+',
        component: TournamentDetail
    },
    {
        path: '/xep-hang',
        component: TournamentRank
    },
    {
        path: '/tin-tuc',
        children: [
            {path: '', component: BlogInterface},
            {path: '/:title+', component: BlogDetailsInterface, props: true},
        ]
    },
    {
        path: '/user',
        component: User,
        children: [
            {path: '', redirect: '/user/user-dashboard'},
            {path: "bang-dieu-khien", component: UserDashboardInterface},
            {path: "giai-dau", component: UserTournament},
            {path: "tran-dau", component: UserMatch},
            {path: "thiet-lap-khac", component: UserProfileOthersettingInterface},
            {path: "doi-mat-khau", component: UserSettingPasswordInterface},
            {path: "sua-thong-tin", component: UserProfileInterface},
            {path: "user-wallet", component: UserWallet},
            {path: "user-invoice", component: UserInvoice},
            {path: "user-coaches", component: UserCoaches},
            {path: "user-match", component: UserMatch},
            {path: "user-bookings", component: UserBookings},
            {path: "notification/all-notifications", component: AllNotifications},
            {path: "user-complete", component: UserComplete},
            {path: "user-ongoing", component: UserOngoing},
            {path: "user-cancelled", component: UserCancelled},
        ]
    },
    {
        path: '/user',
        component: User,
        children: [
            {path: '', redirect: '/user/user-dashboard'},
            {path: "bang-dieu-khien", component: UserDashboardInterface},
            {path: "user-profile-othersetting", component: UserProfileOthersettingInterface},
            {path: "user-setting-password", component: UserSettingPasswordInterface},
            {path: "user-profile", component: UserProfileInterface},
        ]
    },
    {
        path: '/authentication',
        component: Authentication,
        children: [
            {path: '', redirect: '/authentication/register'},
            {path: "register", component: Register},
            {path: "change-password", component: Change_Password},
            {path: "forgot-password", component: Forgot_Password},
        ]
    },
    {
        path: '/pages',
        component: Pages,
        children: [
            {path: '', redirect: '/pages/ve-chung-toi'},
            {path: "our-teams", component: OurTeams},
            {path: "services", component: Services},
            {path: "events", component: Events},
            {path: "pricing", component: Pricing},
            {path: "testimonials", component: Testimonials},
            {path: "testimonials-carousel", component: TestimonialsCarousel},
            {path: "terms-condition", component: TermsCondition},
            {path: "maintenance", component: Maintenance},
            {path: "coming-soon", component: Coming_Soon},
            {path: "service-detail", component: ServiceDetail},
        ]
    },
    {
        path: '/blog',
        component: Blog,
        children: [
            {path: '', redirect: '/blog/blog-list'},
            {path: "blog-list", component: BlogList},
            {path: "blog-list-sidebar-left", component: BlogListSidebarLeft},
            {path: "blog-list-sidebar-right", component: BlogListSidebarRight},
            {path: "blog-grid", component: Blog},
            {path: "blog-grid-sidebar-left", component: BlogGridSidebarLeft},
            {path: "blog-grid-sidebar-right", component: BlogGridSidebarRight},
            {path: "blog-details", component: BlogDetails},
            {path: "blog-details-sidebar-left", component: BlogDetailsSidebarLeft},
            {path: "blog-details-sidebar-right", component: BlogDetailsSidebarRight},
            {path: "blog-carousel", component: BlogCarousel},
        ]
    },
    {
        path: '/coaches',
        component: Coaches,
        children: [
            {path: '', redirect: '/coaches/coaches-map'},
            {path: 'coaches-map', component: CoachesMap},
            {path: 'coaches-map-sidebar', component: CoachesMapSidebar},
            {path: 'coaches-list', component: CoachesList},
            {path: 'coaches-grid-sidebar', component: CoachesGridSidebar},
            {path: 'coaches-list-sidebar', component: CoachesListSidebar},
            {path: 'cage-details', component: CageDetails},
            {path: 'cage-order-confirm', component: CageOrderConfirm},
            {path: 'cage-personalinfo', component: CagePersonalinfo},
            {path: 'cage-checkout', component: CageCheckout},
            {path: 'coach-details', component: CoachDetails},
            {path: 'coach-timedate', component: CoachTimedate},
            {path: 'coach-personalinfo', component: CoachPersonalinfo},
            {path: 'coach-order-confirm', component: CoachOrderConfirm},
            {path: 'coach-payment', component: CoachPayment},
            {path: 'coach-detail', component: CoachDetail},
            {path: 'invoice', component: CoachesInvoice},
            {path: 'coach-request', component: CoachRequest},
            {path: 'coach-chat', component: CoachChat},
            {path: 'coach-wallet', component: CoacheWallet},
            {path: 'coach-earning', component: CoacheEarning},
            {path: 'earning-coaching', component: EarningCoaching},
            {path: 'listing-list', component: ListingList},
            {path: 'listing-grid', component: ListingGrid},
            {path: 'listing-map', component: ListingMap},
            {path: 'venue-details', component: VenueDetails},
            {path: 'all-court', component: AllCourt},
            {path: 'court-active', component: CourtActive},
            {path: 'court-inactive', component: CourtInactive},
            {path: 'add-court', component: AddCourt},
            {path: 'coach-profile', component: CoachProfile},
            {path: 'appointment-details', component: AppointmentDetails},
            {path: 'setting-lesson', component: SettingLesson},
            {path: 'setting-availability', component: SettingAvailability},
            {path: 'setting-password', component: SettingPassword},
            {path: 'profile-othersetting', component: ProfileOthersetting},
            {path: 'coach-booking', component: CoachBooking},
            {path: 'booking-completed', component: BookingCompleted},
            {path: 'booking-cancelled', component: BookingCancelled},
            {path: 'my-profile', component: MyProfile},
        ]
    }
];

export const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: 'active',
    routes,
});

router.beforeEach((to, from, next) => {
    const privatePages = ['/user'];
    const authPages = ['/login', '/register', '/forgot-password', '/change-password', '/reset-password'];
    const authRequired = privatePages.includes(to.path);
    const loggedIn = localStorage.getItem('user');
    const auth = useAuthStore();

    if (authPages.includes(to.path) && loggedIn) {
        return next('/');
    }

    if (authRequired && !loggedIn) {
        auth.returnUrl = to.fullPath;
        return next('/login');
    }

    next();
});
